module.exports = __webpack_public_path__ + "static/creamsoda-bb2697cfc19facf718bdbc81d5427d97.jpg";